
import { Box, Grid, Typography } from '@mui/material'
import React from 'react'
import HelpIconPopover from '../HelpIconPopover';

import '../../../styles/report.css'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js';
import { Doughnut } from 'react-chartjs-2'


const Information = (props) => {

    const showName = props.Settings.OrganizationSettingValues['HIDE PARTICIPANT NAME']
    const showNameFlag = (showName === '0' || showName === 0) ? true : false

    const AssessmentInfo = props.OWS.AssessmentInfo
    const { FirstCalculatedDate
        , FirstCalculatedDateText
        , FirstName
        , LastName
        , MostRecentCalc
        , MostRecentCalcText
        , NameText
        , ResponseCreateDate
        , ResponseCreateDateText
        , AssessmentText } = AssessmentInfo

    return (
        <Box sx={{}}>
            <Typography variant="body1" fontWeight="bold" style={{ textAlign: 'center', fontSize: "20px" }}>
                {AssessmentText}
            </Typography>
            <Box>
                <Grid container direction="row" spacing={1} sx={{ paddingTop: "24px" }}>
                    {showNameFlag && (

                        <Grid item xs={3}>
                            <Typography variant="subtitle2" align="left">{NameText}</Typography>
                        </Grid>
                    )}
                    {showNameFlag && (

                        <Grid item xs={9}>
                            <Typography variant="body2" align="left">{FirstName} {LastName}</Typography>
                        </Grid>
                    )}
                    <Grid item xs={3}>
                        <Typography variant="subtitle2" align="left">{ResponseCreateDateText}</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography variant="body2" align="left">{ResponseCreateDate}</Typography>
                    </Grid>

                    <Grid item xs={3}>
                        <Typography variant="subtitle2" align="left">{FirstCalculatedDateText}</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography variant="body2" align="left">{FirstCalculatedDate}</Typography>
                    </Grid>

                    <Grid item xs={3}>
                        <Typography variant="subtitle2" align="left">{MostRecentCalcText}</Typography>
                    </Grid>
                    <Grid item xs={9}>
                        <Typography variant="body2" align="left">{MostRecentCalc}</Typography>
                    </Grid>
                </Grid>
            </Box>
        </Box>

    )
}

export default Information;